export default function SupportPage() {
  return (
    <div className="mx-auto mt-8 max-w-xl rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <h2 className="text-2xl font-semibold text-pink-600">Priority Support</h2>
      <p className="mt-3 text-sm leading-7 text-slate-600 dark:text-slate-300">
        Contact the support team for faster help with your account, data, or premium workflows.
      </p>
      <a
        href="mailto:support@mekedge.com"
        className="mt-5 inline-flex rounded-full bg-pink-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-pink-700"
      >
        Email Support
      </a>
    </div>
  );
}
